import {
  GET_LOCATION,
  GET_LOCATION_FAIL,
  GET_LOCATION_SUCCESS,
  GET_LOCATIONS,
  GET_LOCATIONS_FAIL,
  GET_LOCATIONS_SUCCESS,
  ADD_NEW_LOCATION,
  ADD_LOCATION_SUCCESS,
  ADD_LOCATION_FAIL,
  UPDATE_LOCATION,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_LOCATION_FAIL,
  DELETE_LOCATION,
  DELETE_LOCATION_SUCCESS,
  DELETE_LOCATION_FAIL,
  SET_STATE_LOCATION,
  UPDATE_LOCATION_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LOCATION,
  payload: loading,
})

export const getLocations = ( params ) => ({
  type: GET_LOCATIONS,
  payload: { params },
})

export const getLocationsSuccess = (locations,totalPages, currentPage) => ({
  type: GET_LOCATIONS_SUCCESS,
  payload: {locations:locations, total:totalPages, currentPage:currentPage}
})

export const getLocationsFail = error => ({
  type: GET_LOCATIONS_FAIL,
  payload: error,
})

export const addNewLocation = location => ({
  type: ADD_NEW_LOCATION,
  payload: location,
})

export const addLocationSuccess = location => ({
  type: ADD_LOCATION_SUCCESS,
  payload: location,
})  

export const addLocationFail = error => ({
  type: ADD_LOCATION_FAIL,
  payload: error,
})

export const updateLocation = location => ({
  type: UPDATE_LOCATION,
  payload: location,
})

export const updateLocationStatus = location => ({
  type: UPDATE_LOCATION_STATUS,
  payload: location,
})

export const updateLocationSuccess = location => ({
  type: UPDATE_LOCATION_SUCCESS,
  payload: location,
})

export const updateLocationFail = error => ({
  type: UPDATE_LOCATION_FAIL,
  payload: error,
})

export const deleteLocation = location => ({
  type: DELETE_LOCATION,
  payload: location,
})

export const deleteLocationSuccess = id => ({
  type: DELETE_LOCATION_SUCCESS,
  id,
})

export const deleteLocationFail = error => ({
  type: DELETE_LOCATION_FAIL,
  payload: error,
})

export const getLocation = () => ({
  type: GET_LOCATION,
})

export const getLocationSuccess = location => ({
  type: GET_LOCATION_SUCCESS,
  payload: location,
})

export const getLocationFail = error => ({
  type: GET_LOCATION_FAIL,
  payload: error,
})
